import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import React from 'react';
import App from './App';
import { store } from './store';
import { Provider } from 'react-redux';
import { META_DATA_MONITORING } from './constant';
import { Helmet } from 'react-helmet';
import { CsConfigProviderLocale } from './contexts/ConfigContext';
import {  CsThemeProvider } from '@com.ctu.iotlab/ui-library';
import "@fontsource/readex-pro"
import '@fontsource/k2d'


const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(
    <Provider store={store}>
        <CsConfigProviderLocale>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5, minimum-scale=1, viewport-fit=cover" />
                <meta name="theme-color" content="#1FC7D4" />
                <meta name="twitter:title" content={META_DATA_MONITORING.title} />
                <meta name="twitter:image" content={META_DATA_MONITORING.image} />
                <meta name="description" content={META_DATA_MONITORING.description} />
                <meta name="msapplication-navbutton-color" content="#ffffff" />
                <meta name="apple-mobile-web-app-status-bar-style" content="#ffffff" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="keywords" content={META_DATA_MONITORING.keyword} />
                <meta name="author" content={META_DATA_MONITORING.author} />
                <meta property="og:title" content={META_DATA_MONITORING.title} />
                <meta property="og:description" content={META_DATA_MONITORING.description} />
                <meta property="og:image" content={META_DATA_MONITORING.image} />
                <meta property="og:url" content={META_DATA_MONITORING.url} />
                <title>{META_DATA_MONITORING.title}</title>
                <link rel="icon" href={META_DATA_MONITORING.icon} />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />
            </Helmet>
            <CsThemeProvider>
                <App />
            </CsThemeProvider>
        </CsConfigProviderLocale>
    </Provider>
)

reportWebVitals()
